<template>
	<el-dialog title="提示" :visible.sync="sucessPopShow2" width="400px" :before-close="handleSucessShow">
		<div class="warning-box success-box">
			<div class="iconfont icon-chenggong"></div>
			<div class="title">
				支付成功
			</div>
			<div class="warning-list">
				<div class="li">
					支付金额：￥{{userAmount}}
				</div>
			</div>
			<div class="btn" @click="handleLimit">
				确定
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			userAmount: {
				type: Number,
				default: 0
			},
			sucessPopShow: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				sucessPopShow2: false
			}
		},
		created() {
			this.sucessPopShow2 = this.sucessPopShow
		},
		watch: {
			sucessPopShow(val) {
				this.sucessPopShow2 = val
			}
		},
		methods: {
			handleLimit() {
				this.$emit('handleLimit')
			},
			handleSucessShow() {
				this.$emit('handleSucessShow')
			},
		}
	}
</script>

<style lang="scss">
	.warning-box {
		width: 307px;
		background: #FFFFFF;
		border-radius: 15px;
		margin: 0 auto;
		box-sizing: border-box;
		padding: 20px 29px;
		padding-top: 0;
		// margin-top: -130px;

		.title {
			margin: 0 auto;
			text-align: center;
			font-size: 17px;
			font-weight: bold;
			color: #000000;
		}

		.btn {
			width: 100%;
			background: #FFCC00;
			line-height: 40px;
			text-align: center;
			color: #262728;
			font-size: 15px;
			font-weight: bold;
			border-radius: 23px;
			cursor: pointer;
		}

		.warning-list {
			margin: 0 0 30px;
			width: 100%;
			font-size: 13px;
			font-weight: 500;
			color: #606366;

			.li {
				margin-bottom: 5px;
				margin-top: 20px;
			}
		}
	}

	.success-box {
		.iconfont {
			text-align: center;
			font-size: 45px;
			color: #16AA74;
			margin: 30px 0 15px;
		}

		.title {
			color: #262728;
		}

		.warning-list {
			margin: 10px 0 40px;

			.li {
				text-align: center;
			}
		}

		.btn {
			width: 200px;
			margin: 0 auto;
		}
	}
</style>
